import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';

@Component({
  selector: 'app-town-dialogbox',
  templateUrl: './town-dialogbox.component.html',
  styleUrls: ['./town-dialogbox.component.scss']
})
export class TownDialogboxComponent implements OnInit {
  displayColumns = ['TownCode', 'TownName', 'TnDsCode'];
  TownForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  townList: any;
  TnCode: any;
  TnName: any;
  TnDsCode: any;
  list;
  town: string;
  townform; any;
  TownSearchForm;
  APIService: string;
  deleteButton: boolean;
  isReadonly = false;
  isReadonlyDelete = false;
  dialogRef: MatDialogRef<any>;
  townDistrictList: any;
  filteredListTownDistrict: any;
  userPermission: any;
  utp: any;
  townCreate = true;
  townUpdate = true;
  townDelete = true;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef2: MatDialogRef<TownDialogboxComponent>,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute, private spinner: NgxSpinnerService,) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'State' && element.PCreate == false) {
          this.townCreate = false;
        }
        if (element.PageName == 'State' && element.PUpdate == false) {
          this.townUpdate = false;
        }
        if (element.PageName == 'State' && element.PDelete == false) {
          this.townDelete = false;
        }
      });
    }
    window.scroll(0, 0);
    this.submitButton = true;
    this.editButton = false;
    this.list = true;
    this.TownForm = this.fb.group({

      TnCode: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-z0-9 - &\\s]*$')]),
      TnName: new FormControl('', [Validators.required]),
      TnDsCode: new FormControl('', [Validators.required]),
    });
    this.TownSearchForm = this.fb.group({
      SearchString: new FormControl('')
    });
    this.getTownData();
    this.fetchTownCode();
    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
    } else if (this.data.key == "Delete") {
      this.prepopulationForDelete(this.data.selected);
    } else {
      // alert(this.data.key)
    }
  }

  getTownData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getTown(payload).subscribe(res => {
      this.townList = res.data;
      this.spinner.hide();
    });
  }

  prepopulation(id) {
    const payload = {};
    // tslint:disable-next-line:no-string-literal

    payload['TnCode'] = id.TnCode;
    // payload['TnName'] = id.TnName;
    // payload['TnDsCode'] = id.TnDsCode;  
    this.isReadonly = true;
    this.umsService.getTown(payload).subscribe((res) => {
      let data = res.data[0];
      if (res.status) {
        this.editButton = true;
        this.submitButton = false;
        this.deleteButton = false;
        this.TownForm = this.fb.group({
          TnCode: new FormControl(data.TnCode, [Validators.required, Validators.pattern('^[a-zA-z0-9 - &\\s]*$')]),
          TnName: new FormControl(data.TnName, [Validators.required]),
          TnDsCode: new FormControl(data.TnDsCode, [Validators.required]),
        });

      } else {
        this.umsService.openSnackbar(res.message);
      }
    });
  }

  submit() {
    if (this.TownForm.invalid) {
      this.TownForm.get('TnCode').markAsTouched();
      this.TownForm.get('TnDsCode').markAsTouched();
      this.TownForm.get('TnName').markAsTouched();
      return;
    } else {
      this.createTown();
    }
  }

  createTown() {
    this.spinner.show();
    this.submitpayload = this.TownForm.value;
    this.umsService.addTown(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      });
  }

  deletedata(id) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        TnCode: id.TnCode,
        TnName: id.TnName,
        TnDsCode: id.TnDsCode,

      },
    };
    this.httpClient.delete(this.APIService + '/masters/town', options)
      .subscribe((s) => {
        // this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.ngOnInit();
          this.dialogRef2.close();
        });
      }, (ERROR: HttpErrorResponse) => {
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
        // this.umsService.openSnackbar(ERROR.error.message);

      });

  }

  prepopulationForDelete(id) {
    const payload = {};
    payload['TnDsCode'] = id.TnDsCode;
    payload['TnCode'] = id.TnCode;
    payload['TnName'] = id.TnName;
    this.isReadonlyDelete = true;
    this.umsService.getTown(payload).subscribe((res) => {
      const data = res.data[0];
      if (res.status) {
        this.editButton = false;
        this.submitButton = false;
        this.deleteButton = true;
        this.TownForm = this.fb.group({

          TnCode: new FormControl(data.TnCode, [Validators.required, Validators.pattern('^[a-zA-z0-9 - &\\s]*$')]),
          TnName: new FormControl(data.TnName, [Validators.required]),
          TnDsCode: new FormControl(data.TnDsCode, [Validators.required]),
        });
      } else {
        this.umsService.openSnackbar(res.message);
      }
    });
  }
  openConformationModalBox() {
    let data = {}
    data['message'] = 'Are You Sure You Want To Delete This Record ?'
    data['title'] = 'Alert'
    data['icon'] = 'fa fa-question'
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        this.deletedata(this.TownForm.value);
      } else {
        this.ngOnInit();
      }
    });
  }

  update() {
    if (this.TownForm.invalid) {
      this.TownForm.get('TnCode').markAsTouched();
      this.TownForm.get('TnName').markAsTouched();
      this.TownForm.get('TnDsCode').markAsTouched();
      return;
    } else {
      this.updateTown();
    }
  }

  updateTown() {
    this.spinner.show();
    this.submitpayload = this.TownForm.value;
    this.umsService.updateTown(this.submitpayload).subscribe(res => {
      this.spinner.hide();

      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      }
    }, (ERROR: HttpErrorResponse) => {
      let data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    });
  }

  addnewrecord(e) {
    this.isReadonly = false;
    this.isReadonlyDelete = false;
    if (e === 'true') {
      this.list = false;
      this.editButton = false;
      this.submitButton = true;
      this.deleteButton = false;
      this.TownForm.reset();
    } else {
      this.list = true;
      this.getTownData();
    }
  }

  editdata(e, k) {
    if (e === 'true') {
      this.list = false;
      this.getTownData();
      this.prepopulation(k);
    } else {
      this.list = true;
    }
  }

  deletee(e, k) {
    if (e === 'true') {
      this.list = false;
      this.getTownData();
      this.prepopulationForDelete(k);
    } else {
      this.list = true;
    }
  }
  fetchTownCode() {
    const payload = {};
    this.umsService.getDistrict(payload).subscribe(res => {
      if (res.status) {
        this.townDistrictList = res.data;
        this.filteredListTownDistrict = this.townDistrictList.slice();
      }
    })
  }


  redirect(to): void {
    this.router.navigate([to]);
  }


}



